// extracted by mini-css-extract-plugin
export default {"centerContent":"ZGAqtNe95sJaYRYHHKna"};